module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (canUserAddAddendums){ 
__p+='\n<div id="addendums-form-container">\n    <div id="addendums-list" class="well"></div>\n    <div class="form-horizontal well">\n        <div class="form-group">\n            <label class="col-sm-3 control-label" for="addendum-comment-text">Addendum Comment</label>\n            <div class="col-sm-9">\n                <textarea rows="5" cols="50" name="addendum-comment-text" id="addendum-comment-text"></textarea>\n            </div>\n        </div>\n        <div class="form-group">\n            <div class="col-sm-7 right">\n                <button id="add-addendum-comment" class="btn btn-primary">Add addendum</button>\n            </div>\n\n        </div>\n    </div>\n</div>\n';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/documents/addendums.html
// module id = 413
// module chunks = 0